import styled, { css } from 'styled-components';
import InputSelectAlternative from '../../../../components/InputSelectAlternative';

interface FieldProps {
  isButon?: boolean;
  gridArea: 'ec' | 'na' | 'em' | 'fu' | 'uf' | 'ci' | 'bt' | 'hp';
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 200px;
  min-height: 300px;

  margin-top: 21px;
  margin-bottom: 20px;
  padding: 30px 25px 0;

  background-color: #ffffff;
  box-shadow: 0px 4px 10px rgba(6, 92, 119, 0.05);
  border-radius: 6px;

  > h1 {
    font-family: 'Raleway';
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;

    color: #4f4f4f;
  }

  @media screen and (max-width: ${({ theme }) => theme.gridBreakpoints.sm}) {
    height: auto;
    min-height: auto;
    padding: 24px 16px;
  }

  @media screen and (max-width: 400px) {
    padding: 20px 12px;
  }
`;

export const InputSelect = styled(InputSelectAlternative)`
  width: 100%;
  min-width: 0;

  > div:first-child {
    border: 1px solid ${(props) => props.theme.colors.gray2};
    border-width: 1px !important;

    &:focus {
      border-width: 1px !important;
    }
  }

  > div .react-select__control {
    border-width: 1px !important;

    &:focus {
      border-width: 1px !important;
    }
  }

  &:focus {
    box-shadow: 0 0 0 0;
    border: 0 none;
    outline: 0;
  }
`;

export const GridContent = styled.div`
  display: grid;
  grid-template: repeat(6, 1fr) / repeat(12, 1fr);
  grid-template-areas:
    'na na na na em em em em hp hp hp hp'
    'fu fu fu fu uf uf ci ci ci ci bt bt';
  grid-column-gap: 45px;
  grid-row-gap: 35px;
  margin-top: 28px;
  width: 100%;
  height: 100%;

  @media screen and (max-width: ${({ theme }) => theme.gridBreakpoints.sm}) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'na'
      'em'
      'hp'
      'fu'
      'uf'
      'ci'
      'bt';
    grid-row-gap: 18px;
  }

  @media screen and (max-width: 400px) {
    grid-row-gap: 14px;
  }
`;

export const Button = styled.button`
  background: ${(props) => props.theme.colors.primary};
  align-self: end;
  justify-self: center;
  border-radius: 100px;
  border: 0;
  padding: 16px 48px;
  color: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.14);
  letter-spacing: 1.25px;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;

  @media screen and (max-width: ${({ theme }) => theme.gridBreakpoints.sm}) {
    width: 100%;
    justify-self: stretch;
  }

  @media screen and (max-width: 400px) {
    padding: 14px 28px;
  }
`;

export const Field = styled.div<FieldProps>`
  display: flex;
  flex-direction: column;
  grid-area: ${({ gridArea }) => gridArea};

  &:nth-child(3) {
    flex-direction: row;
    align-items: center;
    padding-top: 10px;

    > label {
      margin: 5px 10px 0;

      color: ${({ theme }) => theme.colors.primary};
    }

    > div {
      margin-left: 30px;

      > label.switch {
        width: 40px;
        height: 22px;

        > input:checked + span:before {
          transform: translateX(17.5px);
        }

        > span.slider:before {
          height: 12px !important;
          width: 12px !important;
          box-shadow: 0px 4px 4px rgb(0 0 0 / 8%);
          left: 5px;
        }
      }
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.gridBreakpoints.sm}) {
    &:nth-child(3) {
      flex-direction: row;
      align-items: center;
      padding-top: 0;

      > div {
        margin-left: 16px;
      }
    }
  }

  ${({ isButon }) =>
    isButon &&
    css`
      align-self: end;
    `}

  > label {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;

    letter-spacing: 0.01em;

    color: #707683;
    white-space: nowrap;
    > span {
      font-family: 'Raleway';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;

      letter-spacing: 0.01em;

      color: ${({ theme }) => theme.colors.danger};
    }
  }

  > div {
    margin-top: 4px;
    width: 100%;
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type='number'] {
      -moz-appearance: textfield;
    }
    max-height: 43px;
  }

  @media screen and (max-width: 400px) {
    > label {
      white-space: normal;
      font-size: 12px;
      line-height: 14px;
    }

    &:nth-child(3) {
      flex-direction: column;
      align-items: flex-start;

      > label {
        margin: 8px 0 0;
      }

      > div {
        margin-left: 0;
      }
    }
  }
`;
